export default __webpack_public_path__ + "static/media/eventcfg_card.8d39508b.jpg";